import React from 'react';
import Labels from '../../../variables/labels';
import Button from 'components/button/button.jsx';
import { GENERAL } from '../../../assets/images/images';
import Helper from '../../../core/helper/helper';

class CallToAppSample extends React.Component {
  renderCTAContainer = (text) => {
    return (
      <Button className="cta-button-primary d-medium w-100 w-md-auto px-4"  type="button"
        value={text}
        onClick={() => window.open(Helper.linkToAppStore(), '_blank', 'noopener,noreferrer')} />
    );
  }

  renderImage = () => {
    return (
      <div className='w-100' style={{margin: '24px -24px -24px -8px'}}>
        <img className='w-100 d-none d-sm-block' src={Helper.isAndroid() ? GENERAL.callPlayStoreBig : GENERAL.callAppStoreBig} alt=""/>
        <img className='w-100 d-sm-none' src={Helper.isAndroid() ? GENERAL.callPlayStore : GENERAL.callAppStore} alt=""/>
      </div>
    );
  }
  render() {
    return (
    <div className="w-100">
      <h2 className="m-0 p-0">{Labels.AppStoreModal.title}</h2>
      <p className="light mt-4">{Helper.isAndroid() ? Labels.AppStoreModal.message : Labels.AppStoreModal.messageIOS}</p>
      {this.renderCTAContainer(Helper.isAndroid() ? Labels.AppStoreModal.buttonLabel : Labels.AppStoreModal.buttonLabelIOS)}
      {this.renderImage()}
    </div>
  );
  }
}
export default CallToAppSample;